<template>
  <div>
    <a-tabs type="card">
      <a-tab-pane key="1" tab="分公司地址管理"> </a-tab-pane>
    </a-tabs>
    <!-- 搜索 -->
    <a-form :model="searchForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="城市">
            <a-select
              v-model="searchForm.city_id"
              allowClear
              show-search
              option-filter-prop="children"
              placeholder="请选择城市"
              style="width: 100%"
            >
              <a-select-option v-for="item in cityList" :key="item.id" :value="item.id">{{
                item.name
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="地址">
            <a-input v-model="searchForm.address" allowClear placeholder="请输入地址" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="品牌">
            <a-select v-model="searchForm.project" allowClear show-search option-filter-prop="children" placeholder="请选择品牌" style="width: 100%">
              <a-select-option v-for="item in platformList" :key="item.id" :value="item.project">{{
                item.org
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <div class="operbtnbox">
          <a-button type="primary" icon="search" style="margin-right: 20px" @click="search">查询</a-button>
          <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
        </div>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" style="margin-right:20px" @click="handleAdd">添加地址</a-button>
        <a-button ghost type="primary" icon="reload" class="btn-color-success" @click="refreshView">刷新列表</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <a-table row-key="id" :loading="loading" :data-source="data" :pagination="pagination" class="companytable" @change="handleTableChange">
      <a-table-column title="序号" data-index="id" align="center" :width="100" />
      <a-table-column title="城市" data-index="city" align="center" :width="100" />
      <a-table-column title="地址" data-index="address" align="center" :width="300" />
      <a-table-column title="品牌" align="center" :width="240">
        <template slot-scope="text, record">
          <span>{{ record.projectText }}</span>
        </template>
      </a-table-column>
      <a-table-column title="发布人" :width="180" align="left">
        <template slot-scope="text, record">
          <div>
            <span v-if="record.staff_name">{{ record.staff_name }}</span>
            <span v-if="record.staff_name && record.staff_number"> ({{ record.staff_number }})</span>
            <span v-else>-</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="时间" :width="240" align="left">
        <template slot-scope="text, record">
          <div>
            <span>发布：</span>
            <span v-if="record.created_at">{{ record.created_at | parseTime }}</span>
            <span v-else>-</span>
          </div>
          <div>
            <span>更新：</span>
            <span v-if="record.updated_at">{{ record.updated_at | parseTime }}</span>
            <span v-else>-</span>
          </div>
        </template>
      </a-table-column>
      <a-table-column title="操作" data-index="mo4ne5y" :width="140" align="center" fixed="right">
        <template slot-scope="text, record">
          <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button>
          <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
        </template>
      </a-table-column>
    </a-table>

    <!-- 添加公司 -->
    <AddFiliale v-if="visible" v-model="visible" :isEdit="isEdit" :params="waitItem" :platformList="platformList" @handleOver="getList" />
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, form } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import pagination from '@/composables/pagination'
import AddFiliale from './components/AddFiliale'
import api from '@/api/'

export default {
  components: { AddFiliale },
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      times: [],
      platformList: [],
      platformLongList: [],
      searchForm: { ...searchForm },
      cityList: []
    })

    onMounted(async () => {
      await methods.getPlatLongform()
      await methods.getPlatform()
      await methods.getCityList()
      methods.getList()
    })

    const methods = {
      search() {
        _this.pagination.current = 1
        this.getList()
      },

      async getList() {
        _this.loading = true
        state.searchForm.end_time = state.times[1]
        const res = await api.companyList({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize
        })
        const { branchOfficeAddress, pagination } = res.data
        _this.data = branchOfficeAddress.map(item => {
          return {
            ...item,
            projectText: this.getOrgList(item)
          }
        })
        _this.pagination.total = pagination.total
        _this.loading = false
      },

      async getCityList() {
        const res = await api.getCityList({
          parent_id: '',
          is_tree: "0",
          level: "2"
        })
        state.cityList = res.data
      },

      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data.filter(item => {
          if (item.parent_id === 0) {
            return item
          }
        })
      },

      getOrg(record, type) {
        const obj = _this.platformLongList.find(
          (item) =>
            Number(item.project) === Number(record.project) &&
            Number(item.staff_style) === Number(record.staff_style) &&
            Number(item.type) === Number(record.type)
        )
        return obj ? obj[type] : ''
      },

      getOrgList(record) {
        if (record.businessLines.length === 0) {
          return '全部'
        } else {
          return record.businessLines.map(item => this.getOrg(item, 'org')).join('、')
        }
      },

      async getPlatLongform() {
        const res = await api.LineList()
        state.platformLongList = res.data
      },

      async inputDebounce(sort, data) {
        const res = await api.updateLink(data)
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
        }
      },

      // 刷新视图
      refreshView() {
        this.handleClear()
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      handleClear() {
        state.searchForm = { ...searchForm }
        state.times = []
        this.search()
      },

      handleAdd() {
        _this.visible = true
        _this.isEdit = false
        _this.waitItem = null
      }
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style lang="less" scoped>
.img-width {
  cursor: pointer;
  width: 60px;
  height: 50px;
  width: 100%;
  object-fit: contain;
}

.operbtnbox {
  padding: 4px 0;
}

.companytable {
  margin-top: 20px;
}
</style>
